import { IndividualProgressAccordions } from './IndividualProgressAccordions';
// import { MaterialsSidebar } from '../shared-components/MaterialsSidebar';
import { ProjectHub } from '@platform/client';
import { SimplifiedUserRole } from '@platform/client/schemas';
import { HubPage } from '../HubPage';
import { useParams } from 'wouter';
import { ProjectDetailsSection } from '../shared-components/ProjectDetailsSection';
import { SideBar } from '../shared-components/SideBar';
import { ROUTES } from '../../routes/consts';

const IndividualProjectTrackerPage = () => {
  const { assignmentDiscoveryId } = useParams<{ assignmentDiscoveryId: string }>();
  const { data: hubData, isSuccess } = ProjectHub.useGetProjectHubData({
    assignment_discovery_id: parseInt(assignmentDiscoveryId),
  });
  if (!isSuccess) {
    return null;
  }
  return (
    <HubPage
      projectDetails={
        <ProjectDetailsSection
          status={hubData.status}
          project={hubData?.project ? hubData.project : undefined}
          organization={hubData?.organization}
        />
      }
      progressAccordions={<IndividualProgressAccordions hubData={hubData} />}
      sideBarContent={
        <>
          <SideBar
            title={
              hubData.userType === SimplifiedUserRole.PROFESSIONAL ?
                'Representative'
              : 'Professional'
            }
            items={[
              {
                type: 'contact',
                firstname:
                  hubData.userType === SimplifiedUserRole.PROFESSIONAL ?
                    hubData.representative.firstname
                  : hubData.professional.firstname,
                lastname:
                  hubData.userType === SimplifiedUserRole.PROFESSIONAL ?
                    hubData.representative.lastname
                  : hubData.professional.lastname,
                email:
                  hubData.userType === SimplifiedUserRole.PROFESSIONAL ?
                    hubData.representative.email
                  : hubData.professional.email,
                avatarUrl:
                  hubData.userType === SimplifiedUserRole.PROFESSIONAL ?
                    (hubData.representative.avatar ?? undefined)
                  : (hubData.professional.avatar ?? undefined),
                profileUrl:
                  hubData.userType === SimplifiedUserRole.REPRESENTATIVE ?
                    `${ROUTES.DIRECTORY}/professionals/${hubData.professional.id}`
                  : undefined,
              },
            ]}
          />
          {/* <MaterialsSidebar /> */}
        </>
      }
    />
  );
};

export default IndividualProjectTrackerPage;
